module.exports = "<div class=\"wrapper wrapper-content animated fadeInUp\"> <div class=ibox> <breadcrumb></breadcrumb> <iframe-template path-url={{url}} css=100% key=inputApprove></iframe-template> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/statistics/chartAnalysis/inputApprove/view/inputApprove.html
// module id = Wb+C
// module chunks = 0